export default "__VITE_PUBLIC_ASSET__8f2c1ba9__"